import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 🔥 Fix Webpack 5 buffer polyfill issue
import { Buffer } from "buffer";
window.Buffer = window.Buffer || Buffer;

// Handle wallet extension errors gracefully (MetaMask, etc.)
// Don't block them - just prevent uncaught errors from crashing the site
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || '';
  if (msg.includes('MetaMask') || msg.includes('wallet') || msg.includes('ethereum') || msg.includes('extension')) {
    event.preventDefault();
    console.debug('Wallet extension error suppressed:', msg);
  }
});

// Suppress UNSAFE_componentWillMount warning from react-helmet-async
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('UNSAFE_componentWillMount')) {
    return;
  }
  originalError.call(console, ...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
